import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ProtectedRoute = ({ children, requireSubscription = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Subscription gate state
  const [subStatus, setSubStatus] = useState(null); // null = loading, string = resolved
  const [subError, setSubError] = useState(false);

  useEffect(() => {
    let cancel = false;
    if (!requireSubscription || loading || !user) return undefined;

    // Admins bypass billing gate
    if (user.role === 'admin') {
      setSubStatus('active');
      return undefined;
    }

    axios
      .get(`${API}/billing/status`)
      .then((r) => {
        if (cancel) return;
        setSubStatus(r.data?.subscription_status || 'inactive');
      })
      .catch(() => {
        if (cancel) return;
        // Fail-open on transient billing errors so we don't lock active users out
        setSubError(true);
        setSubStatus('active');
      });
    return () => {
      cancel = true;
    };
  }, [requireSubscription, loading, user]);

  if (loading || (requireSubscription && user && subStatus === null)) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <p className="text-[#1a1a1a]/60">Loading...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (requireSubscription && !subError && subStatus !== 'active' && subStatus !== 'canceling') {
    return <Navigate to="/preview" state={{ from: location.pathname }} replace />;
  }

  return children;
};

export default ProtectedRoute;
